/**
 * Display form of an order-line quantity: "x5", not a bare "5" (card #302).
 *
 * ONE place for the format so the order page, the locked cart/order table and
 * any later read-only quantity cell cannot drift. The confirmation emails
 * render the same form in `templates/email/_order_items_table.html`.
 *
 * Returns "" for a missing or non-numeric value rather than "xNaN" or "x":
 * a blank cell is honest, a malformed one reads as a bug.
 *
 * @param {number|string|null|undefined} quantity
 * @returns {string}
 */
export function formatQuantity(quantity) {
  if (quantity === null || quantity === undefined || quantity === "") return "";
  const n = Number(quantity);
  if (!Number.isFinite(n)) return "";
  return `x${n}`;
}
